import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/helpers/humanTime';
export default class BadgeUserList extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    // Load articles
    this.attrs.state.refreshParams({
      filter: {
        badge: this.attrs.badgeId
      },
      sort: '-assignedAt'
    }, 1);
  }
  view() {
    const state = this.attrs.state;
    let loading = null;
    if (state.isInitialLoading() || state.isLoadingNext()) {
      loading = LoadingIndicator.component({
        size: 'large'
      });
    } else if (state.hasNext()) {
      loading = Button.component({
        className: 'Button',
        icon: 'fas fa-chevron-down',
        onclick: state.loadNext.bind(state)
      }, app.translator.trans('core.forum.discussion_list.load_more_button'));
    }

    // No items
    if (state.isInitialLoading() && state.isEmpty()) {
      return m(LoadingIndicator, null);
    }

    // No items
    if (state.isEmpty()) {
      return m("div", {
        className: 'BadgeUserList-empty'
      }, app.translator.trans('v17development-flarum-badges.forum.no_received'));
    }
    return m("div", null, m("ul", {
      className: 'BadgeUserList'
    }, state.getPages().map(pg => {
      return pg.items.map(userBadge => {
        return m("li", null, m(Link, {
          href: app.route('user.badges', {
            username: userBadge.user().slug()
          }),
          className: 'BadgeUserList-user'
        }, m(Avatar, {
          user: userBadge.user()
        }), m("div", {
          className: 'BadgeUserList-userinfo'
        }, m("h4", null, userBadge.user().displayName()), m("p", null, app.translator.trans('v17development-flarum-badges.forum.badge.received_on', {
          date: humanTime(userBadge.assignedAt())
        })))));
      });
    })), loading && m("div", {
      className: "SupportSearchList-loadMore"
    }, loading));
  }
}
flarum.reg.add('v17development-user-badges', 'forum/components/BadgeUserList', BadgeUserList);